import React, {useEffect, useRef} from "react";
import {Grid} from "@mui/system";
import style from "../../assets/css/login-register.module.scss";
import {Button, FormControl, InputLabel} from "@mui/material";
import GlobalPassword from "../global-fields/GlobalPassword";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useFormik} from "formik";
import * as yup from "yup";
import {GoArrowLeft} from "react-icons/go";
import {LINK_CHECK, UPDATE_PASS} from "../../constants/apiConstant";
import {selectUiState, setUiData} from "../../store/uiSlice";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../constants/helper";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {uid} = useParams();
  const {dynamicHeaderHeight} = useSelector(selectUiState);

  let initialFormikVals = {
    password: "",
    confirmPassword: "",
  };
  const checkLink = async (e) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );
    let data = {user_id: uid};

    const options = {
      method: LINK_CHECK.method,
      headers: LINK_CHECK.headers,
      body: JSON.stringify(data),
    };

    fetch(LINK_CHECK.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          GlobalNotificationPopup({type: "error", message: res?.message});
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          removeCookies("isLogin");
          navigate("/");
        } else if (res.status == 1) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        console.log("error", error);
        navigate("/");
      });
  };

  // useEffect(() => {
  //   if (type === "email") {
  //     // setEnableCounter(false)
  //     checkLink()
  //   } else if (type) {
  //     setEnableCounter(true)

  //   }
  // }, [])
  const hasCheckedLink = useRef(false);

  useEffect(() => {
    if (!hasCheckedLink.current) {
      hasCheckedLink.current = true;
      checkLink();
    }
  }, []);

  const handleResetBtn = async (e) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {...e, user_id: uid};

    const options = {
      method: UPDATE_PASS.method,
      headers: UPDATE_PASS.headers,
      body: JSON.stringify(data),
    };

    fetch(UPDATE_PASS.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          GlobalNotificationPopup({type: "error", message: res?.message});
          removeCookies("isLogin");
        } else if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          removeCookies("isLogin");
          navigate(`/login`);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues: initialFormikVals,
    onSubmit: (values) => {
      delete values.confirmPassword;
      handleResetBtn(values);
    },
    validationSchema: yup.object().shape({
      password: yup
        .string()
        .trim()
        .required("Password is required!")
        .matches(
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/,
          "Password must be at least 8 characters long, include 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number."
        ),
      confirmPassword: yup
        .string()
        .trim()
        .required("Confirm Password is required!")
        .oneOf([yup.ref("password"), null], "Passwords must match."),
    }),
  });

  return (
    <>
      <div className={style.logMainWrapper} style={{height: `100vh`}}>
        {/* <Link to="/">     <img className={style.logLogoMain} src={Logo} /> </Link> */}
        <div className={style.logLeftMain}>
          <Grid container spacing={1} justifyContent="center">
            <Grid size={{xs: 12, lg: 7, xl: 6}}>
              <div className={style.log_title}>
                <h2> Set New Password </h2>
                <p>Must be at least 8 characters.</p>
              </div>

              <form
                autoComplete="false"
                autoSave="false"
                onSubmit={formik.handleSubmit}
              >
                <Grid container spacing={1} justifyContent="center">
                  <Grid
                    size={{xs: 12, lg: 12}}
                    sx={{mt: 2}}
                    className={style.logLabel}
                  >
                    <div className={style.logPassField}>
                      <InputLabel sx={{mb: 1}} style={{color: "black"}}>
                        New Password
                      </InputLabel>
                      <FormControl fullWidth variant="outlined">
                        <GlobalPassword
                          id="password"
                          name="password"
                          type="password"
                          label="Password"
                          value={formik.values.password}
                          onChange={(e) =>
                            formik.setFieldValue("password", e.target.value)
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                          }
                          helperText={
                            formik.touched.password && formik.errors.password
                          }
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid
                    size={{xs: 12, lg: 12}}
                    sx={{mt: 2}}
                    className={style.logLabel}
                  >
                    <div className={style.logPassField}>
                      <InputLabel sx={{mb: 1}} style={{color: "black"}}>
                        Confirm New Password
                      </InputLabel>
                      <FormControl fullWidth variant="outlined">
                        <GlobalPassword
                          id="confirmPassword"
                          name="confirmPassword"
                          type="password"
                          label="confirmPassword"
                          value={formik.values.confirmPassword}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "confirmPassword",
                              e.target.value
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.confirmPassword &&
                            Boolean(formik.errors.confirmPassword)
                          }
                          helperText={
                            formik.touched.confirmPassword &&
                            formik.errors.confirmPassword
                          }
                        />
                      </FormControl>
                    </div>
                  </Grid>

                  <Grid size={{xl: 12, xs: 12}}>
                    <div className={style.logBtnMain}>
                      <Button
                        fullWidth
                        variant="contained"
                        className={style.logResetBtn}
                        type="submit"
                      >
                        {" "}
                        Reset Password{" "}
                      </Button>
                      <Link to="/login">
                        {" "}
                        <Button variant="outline" className={style.logBackBtn}>
                          {" "}
                          <GoArrowLeft /> Back to Login{" "}
                        </Button>
                      </Link>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>

        {/* Back image div start */}
        <div className={style.logRightMain}>
          <div className={style.logRightWrapper}></div>
        </div>
        {/* Back image div end */}
      </div>
    </>
  );
};

export default ResetPassword;
